<template>
    <div class="box">
        <div class="title">本月报警次数</div>
        <div class="content">
            <div class="ref2" ref="ref2">
                <!-- <dv-active-ring-chart :config="config" style="width: 95%; height: 100%" /> -->
                <dv-scroll-ranking-board class="dv-scroll-ranking-board" :config="config"
                    style="width: 95%; height: 100%" />
                <!-- <dv-capsule-chart :key="key" :config="config" style="width: 95%; height: 100%" /> -->
            </div>
            <div class="ref1" ref="ref1"></div>
        </div>
        <msLoading ref="loading"></msLoading>
    </div>
</template>

<script>
import msLoading from '@/components/common/msLoading.vue';
import { QueryCompanyProject, QueryAlermMessage } from '@/api/index.js';
import moment from 'moment';
export default {
    name: 'rightcard3',
    data() {
        return {
            alermMessageData: [],
            key: 0,
            config: {
                data: [],
                waitTime: "5000",
                carousel: 'page'
            },
        };
    },
    mounted() {
        this.beforDeviceDataComputerLine();
    },
    methods: {
        // 本月报警次数
        async beforDeviceDataComputerLine() {
            this.$refs.loading.show();
            let companyId = JSON.parse(localStorage.getItem('companyInfo')).companyId;
            // 获取公司绑定的项目列表
            const projectListResult = await QueryCompanyProject({ companyId: companyId, limit: 100, offset: 0 });
            console.log(projectListResult);
            let projectStr = '';
            let projectRowResult = projectListResult.data.rows;
            projectRowResult.forEach((item, index) => {
                if (index == projectRowResult.length - 1) {
                    projectStr = `${projectStr}${item.projectId}`;
                } else {
                    projectStr = `${projectStr}${item.projectId},`;
                }
            });

            // 开始日期时间戳
            let startTimeStamp = moment().month(moment().month()).startOf('month').valueOf();
            // 结束日期时间戳
            let endTimeStamp = new Date().getTime();
            // 对两个日期进行格式化
            let startDate = moment(startTimeStamp * 1).format('MM-DD');
            let endDate = moment(endTimeStamp * 1).format('MM-DD');
            // 当前月份
            let monthNow = endDate.split('-')[0];
            let xData = [];
            for (let i = 1; i <= endDate.split('-')[1] * 1; i++) {
                // 判断i是否小于10
                if (i < 10) {
                    xData.push(`${monthNow}-0${i}`);
                } else {
                    xData.push(`${monthNow}-${i}`);
                }
            }

            // 调用根据时间戳获取报警数据
            const result = await QueryAlermMessage({
                companyId: companyId,
                projectStr: projectStr,
                startTimeStamp: startTimeStamp,
                endTimeStamp: endTimeStamp
            });

            this.alermMessageData = result.data;

            // this.config.data[0].value = this.alermMessageData.length;
            this.key++;
            let deviceMessageArr = [];
            let deviceArr = []
            result.data.forEach((item) => {
                // console.log(this.$store.state.deviceNowData, '---------------');
                let alarmDevice = this.$store.state.deviceNowData.filter(i => { return i.deviceName == item.deviceName })
                deviceArr.push(alarmDevice[0].anotherName)
                item.date = moment(item.createTime * 1).format('MM-DD');
                deviceMessageArr.push(item.date);
            });
            let nameNum = deviceArr.reduce((pre, cur) => {
                if (cur in pre) {
                    pre[cur]++
                } else {
                    pre[cur] = 1
                }
                return pre
            }, {})

            let dataArr = []
            for (let key in nameNum) {
                let obj = {
                    name: key,
                    value: nameNum[key]
                }
                // console.log(key, nameNum[key], 'keykeykeykeykey');
                dataArr.push(obj)
            }
            this.config.data = dataArr
            this.config = { ...this.config }
            console.log(this.config.data, 'this.config.data');

            // this.config.data[1].value = PH
            // this.config.data[2].value = COD
            // this.config.data[3].value = YEWEI
            // this.config.data[4].value = EC
            // 数据
            let vSeries = [];
            // searies数据计算
            xData.forEach((item) => {
                let number = 0;
                deviceMessageArr.forEach((ite) => {
                    if (item == ite) {
                        number++;
                    }
                });
                vSeries.push(number);
            });
            console.log(vSeries, 'vSeries');
            this.setCanva1(xData, vSeries);
        },
        setCanva1(xData, vSeries) {
            this.$echarts.init(this.$refs.ref1).setOption({
                grid: {
                    left: 0,
                    top: 10,
                    right: 0,
                    bottom: 0,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',

                    data: xData,
                    axisLabel: {
                        color: '#fff'
                    }
                },
                yAxis: {
                    show: false,
                    type: 'value'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        label: {
                            backgroundColor: '#6a7985'
                        },
                    }
                },
                series: [
                    {
                        data: vSeries,
                        type: 'line',
                        lineStyle: {
                            width: 0
                        },

                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: 'rgb(0, 221, 255)'
                                },
                                {
                                    offset: 0,
                                    color: 'rgb(77, 119, 255)'
                                }
                            ])
                        }
                    }
                ]
            });
            this.$refs.loading.hide();
        }
    },
    components: {
        msLoading
    }
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    position: relative;
    padding: 0.2rem;

    .title {
        color: aqua;
        font-size: 0.4rem;
        box-sizing: border-box;
        font-weight: bold;
    }

    .content {
        overflow: hidden;
        box-sizing: border-box;
        height: 100%;

        .ref1 {
            height: 50%;
            box-sizing: border-box;
        }

        .ref2 {
            height: 50%;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #14283e;
            box-sizing: border-box;
        }


    }

    .dv-scroll-ranking-board {
        ::v-deep(.row-item) {
            height: 28px !important;
        }

    }

    .dv-scroll-ranking-board {
        ::v-deep(.info-name) {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

}
</style>